module.exports = {
  getUID: () => {
    return Date.now().toString(36) + Math.random().toString(36).substr(3)
  }
}


// WEBPACK FOOTER //
// ./src/utils.js